import isNil from "lodash/isNil";
import { useNavigate, useParams } from "react-router-dom";
import { PROFILE_HOUSEHOLD_MEMBER_DATA_EDIT_PATH } from "../../../../../../constants/env";
import { useProductRequisites } from "../../../../../hooks/use-product-requisites/useProductRequisites";
import { addMemberIdToPath } from "../../../../../utils/add-member-id-to-path";
import { ConfirmExitContent } from "../../../modals/confirm-exit-content/confirm-exit-content";

export function ConfirmExitEditHouseholdMemberRelationshipModal(): JSX.Element {
  const navigate = useNavigate();
  const { productRequisites } = useProductRequisites();
  const { memberId } = useParams<{ memberId?: string }>();

  function handleOnExit() {
    if (!memberId) return;

    const householdMemberEditPagePath = addMemberIdToPath(PROFILE_HOUSEHOLD_MEMBER_DATA_EDIT_PATH, memberId);
    const redirectPath = !isNil(productRequisites) ? productRequisites.productSurveyPath : householdMemberEditPagePath;

    navigate(redirectPath, { replace: true });
  }

  return <ConfirmExitContent onExit={handleOnExit} />;
}
